import React from 'react';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import PencilBuddy from './PencilBuddy';

export default function OcrSetup({ progress, error, onRetry, onUseLetters }) {
  const opening = progress.stage === 'initializing';
  const percent = Number.isFinite(progress.percent) ? progress.percent : 0;
  const stage = error ? 'Kalemimiz henüz hazır değil.' : opening ? 'Kalemini açıyoruz…'
    : progress.stage === 'models' ? 'Yazma paketi yükleniyor…' : 'Yazma araçları açılıyor…';
  return <section className="dyw-ocr-setup" aria-label="Serbest yazma hazırlığı">
    <div className="dyw-ocr-setup-art" aria-hidden="true"><PencilBuddy /></div>
    <h2>{error ? 'Birlikte yeniden deneyelim' : 'Kalemini hazırlıyoruz!'}</h2>
    <p className="dyw-ocr-setup-stage" role={error ? 'alert' : 'status'}>{stage}</p>
    {!error && <>
      <LinearProgress className="dyw-ocr-setup-progress" variant={opening ? 'indeterminate' : 'determinate'}
        value={percent} aria-label={opening ? 'Kalem açılıyor' : 'Yazma paketinin yüklenmesi'}
        aria-valuetext={opening ? 'Paket hazır, kalem açılıyor' : `%${percent} yüklendi, %${100 - percent} kaldı`} />
      <p className="dyw-ocr-setup-percent">{opening ? 'Yazma paketi hazır!' : `Yazma paketi: %${percent} yüklendi · %${100 - percent} kaldı`}</p>
    </>}
    <p className="dyw-ocr-setup-note">{error
      ? 'Yazma araçlarını açamadık. Bağlantını kontrol edip yeniden deneyebilir ya da harflerle yazabilirsin.'
      : 'İlk oyundan önce küçük bir hazırlığımız var. İlk açılış biraz sürebilir. Azıcık sabır; birazdan birlikte yazacağız!'}</p>
    <div className="dyw-ocr-setup-actions">
      {error && <Button className="sound-hunt-control" onClick={onRetry}>Yeniden dene</Button>}
      <Button className="sound-hunt-control" onClick={onUseLetters}>Harflerle yazmaya dön</Button>
    </div>
  </section>;
}
